import type { FC } from 'react';
import { lazy } from 'react';
import { useDocumentExchangeRoot } from 'src/apis/document-exchange/use-document-exchange-root';
import { PageSpinner } from 'src/components/spinner-container';
import { Forbidden } from 'src/utils/errors';

const Page = lazy(() => import('./page'));

export const UploadDocumentsToShippers: FC = () => {
  const documentExchange = useDocumentExchangeRoot();

  if (!documentExchange.response) return <PageSpinner />;

  if (
    !documentExchange.response.data._links.shippers ||
    !documentExchange.response.data._links.uploadFile ||
    !documentExchange.response.data._links.publishOperatorDocument
  )
    throw new Forbidden();

  return (
    <Page
      shippersLink={documentExchange.response.data._links.shippers.href}
      publishOperatorDocumentLink={
        documentExchange.response.data._links.publishOperatorDocument.href
      }
      uploadDocumentLink={documentExchange.response.data._links.uploadFile.href}
    />
  );
};
